// extracted by mini-css-extract-plugin
export default {"menu":"index_menu_dvJrB","menuList":"index_menuList_gzOQ2"};